import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, XCircle, Info, RefreshCw, Bell } from 'lucide-react';
import api from '../services/apiClient';
import useAuthStore from '../store/authStore';
import { Button } from '../components/ui';
import { toast } from '../components/toast';

const ICONS = { error: XCircle, warning: AlertTriangle, info: Info };
const BADGE = { error: 'red', warning: 'yellow', info: 'blue' };

export default function Notifications() {
  const switchCompany = useAuthStore((s) => s.switchCompany);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try { setData(await api.get('/notifications')); }
    catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const go = (item) => {
    if (item.companyId) switchCompany(item.companyId);
    navigate(item.link || '/');
  };

  return (
    <div>
      <div className="page-actions">
        <Button variant="secondary" onClick={load}><RefreshCw size={15} /> Atualizar</Button>
      </div>

      {loading ? <p className="muted">Carregando…</p> : (
        <div className="grid">
          {(!data || data.items.length === 0) && (
            <div className="card center muted">Tudo em dia! Nenhum alerta no momento. 🎉</div>
          )}
          {data && data.items.map((item, i) => {
            const Icon = ICONS[item.level] || Info;
            return (
              <div key={i} className="card row between" style={{ cursor: 'pointer' }} onClick={() => go(item)}>
                <div className="row">
                  <span className={`badge ${BADGE[item.level]}`}><Icon size={13} /></span>
                  <div>
                    <strong>{item.companyName}</strong>
                    <div className="muted">{item.message}</div>
                  </div>
                </div>
                <span className="muted">→</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
